<template>
    <div class="row">
        <page-title :title="$t('reportData.participants.menuTitle')" :showTitle="false"></page-title>
        <div class="card mx-auto mt-2 px-0">
            <div class="card-header bg-primary text-white">
                <div class="card-title h5 m-0">
                    {{ $t('reportData.participantsToMigrationTitle') }}
                </div>
            </div>

            <!--<div class="card-header" v-if="showReportDataParticipantsToMigrationSettings">
            <span v-if="showReportDataParticipantsToMigrationSettings">
                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   @click.stop="changeGridSettings('reportDataParticipantsToMigrationGrid')"
                   data-toggle="tooltip"
                   :title="$t('buttons.settings.tooltipText')"></i>
            </span>

            <div v-if="showReportDataParticipantsToMigrationSettings">
                <GridUserSettings ref="reportDataParticipantsToMigrationSettings"
                                  :visible="showReportDataParticipantsToMigrationSettingsForm"
                                  :grid="$refs['reportDataParticipantsToMigrationGrid']"
                                  :componentName="componentName">
                </GridUserSettings>
            </div>
        </div>-->

            <div class="card-body">
                <div v-if="diffCheckerFilter" class="form-row">
                    <vs-checkbox v-for="item in diffCheckerFilter"
                                 :key="item.key"
                                 v-model="item.checked"
                                 class="m-2">
                        {{ item.key }}
                    </vs-checkbox>
                </div>

                <div class="btn-toolbar justify-content-between mt-0 mb-2" role="toolbar">
                    <div class="form-inline col-6">
                        <button class="btn btn-secondary" @click.stop="setFilterYear(-1)">
                            <i class="fas fa-caret-left"></i>
                            Prev year
                        </button>

                        <date-only-picker :showTime="false"
                                          v-model="diffCheckerFilterStartDate">
                        </date-only-picker>

                        <button class="btn btn-secondary" @click.stop="setFilterYear(1)">
                            <i class="fas fa-caret-right"></i>
                            Next year
                        </button>
                    </div>

                    <div class="input-group">
                        <!--<input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">-->
                        <button class="btn btn-secondary" @click.stop="refresh">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>

                        <button class="btn btn-secondary" @click.stop="hideUnselected">
                            <i class="fas fa-eye-slash"></i>
                            Only selected
                        </button>
                        <button class="btn btn-secondary" @click.stop="showUnselected">
                            <i class="fas fa-eye"></i>
                            Show all
                        </button>
                    </div>
                </div>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="reportDataParticipantsToMigrationGrid"
                            :data-source-ref="'datasource1'"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="false"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="gridOptions.toolbar"
                            :dataBound="dataBound"
                            :excel="gridOptions.excel"
                            name="reportDataParticipantsToMigrationGrid">


                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="' '"
                                       :filterable="false"
                                       :sortable="false"
                                       v-if="showBtns && (hasEventReadRights || hasParticipantReadRights)"
                                       :width="80"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'hasDiffs'"
                                       :width="100"
                                       :template="hasDiffsCellTemplate"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'id'"
                                       :title="$t('reportData.participants.participantId')"
                                       :width="110"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fullName'"
                                       :title="$t('reportData.participants.fullName')"
                                       :width="280"
                                       :lockable="true"
                                       :locked="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationTypeName'"
                                       :title="$t('reportData.participants.participationTypeName')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>

                    <kendo-grid-column :field="'title'"
                                       :title="$t('reportData.participants.title')"
                                       :width="130"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Title'"
                                       :width="130"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'registerEntityId'"
                                       :title="$t('reportData.participants.registerEntityId')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'"
                                       :title="$t('reportData.events.eventName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'shortDates'"
                                       :title="$t('reportData.events.shortDates')"
                                       :width="200"
                                       :sortable="false"
                                       :filterable="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'position'"
                                       :title="$t('reportData.participants.position')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Position'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'positionStatistics'"
                                       :title="$t('reportData.participants.positionStatistics')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionName'"
                                       :title="$t('reportData.participants.institutionName')"
                                       :width="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'migrationInstitutionName'"
                                       :title="'m_InstitutionName'"
                                       :width="250">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'institutionCity'"
                                       :title="$t('reportData.participants.institutionCity')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_InstitutionCity'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participationName'"
                                       :title="$t('reportData.participants.participationName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_ParticipationName'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'email'"
                                       :title="$t('reportData.participants.email')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Email'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'phone'"
                                       :title="$t('reportData.participants.phone')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Phone'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'mobilePhone'"
                                       :title="$t('reportData.participants.mobilePhone')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_MobilePhone'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'salutation'"
                                       :title="$t('reportData.participants.salutation')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'gender'"
                                       :title="$t('reportData.participants.gender')"
                                       :width="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Gender'"
                                       :width="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'egn'"
                                       :title="$t('reportData.participants.egn')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_EGN'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'firstName'"
                                       :title="$t('reportData.participants.firstName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_FirstName'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'middleName'"
                                       :title="$t('reportData.participants.middleName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_MiddleName'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'lastName'"
                                       :title="$t('reportData.participants.lastName')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_FLastName'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'reasonForAdmission'"
                                       :title="$t('reportData.participants.reasonForAdmission')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_ReasonForAdmission'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'statusName'"
                                       :title="$t('reportData.participants.statusName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deployed'"
                                       :title="$t('reportData.participants.deployed')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Deployed'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'cityOfCurrentAddress'"
                                       :title="$t('reportData.participants.cityOfCurrentAddress')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_CityOfCurrentAddress'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'employment'"
                                       :title="$t('reportData.participants.employment')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Employment'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'education'"
                                       :title="$t('reportData.participants.education')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Education'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'partRequsetFillDate'"
                                       :title="$t('reportData.participants.partRequsetFillDate')"
                                       :width="300"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_PartRequsetFillDate'"
                                       :width="300"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'accommodationRequest'"
                                       :title="$t('reportData.participants.accommodationRequest')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_AccommodationRequest'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'datesForNights'"
                                       :title="$t('reportData.participants.datesForNights')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_DatesForNights'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'roomType'"
                                       :title="$t('reportData.participants.roomType')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_RoomType'"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'travelers'"
                                       :title="$t('reportData.participants.travelers')"
                                       :width="200"
                                       :template="travelersCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Travelers'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'vegetarianMenu'"
                                       :title="$t('reportData.participants.vegetarianMenu')"
                                       :width="200"
                                       :template="menuCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_VegetarianMenu'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'note'"
                                       :title="$t('reportData.participants.note')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_Note'"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isMigrant'"
                                       :title="$t('reportData.participants.isMigrant')"
                                       :width="150"
                                       :template="migrantCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsMigrant'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isForeigner'"
                                       :title="$t('reportData.participants.isForeigner')"
                                       :width="150"
                                       :template="foreignerCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsForeigner'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isMemberOfAMinority'"
                                       :title="$t('reportData.participants.isMemberOfAMinority')"
                                       :width="170"
                                       :template="minorityCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsMemberOfAMinority'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isOfGypsyOrigin'"
                                       :title="$t('reportData.participants.isOfGypsyOrigin')"
                                       :width="150"
                                       :template="gipsyCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsOfGypsyOrigin'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'withDisabilities'"
                                       :title="$t('reportData.participants.withDisabilities')"
                                       :width="170"
                                       :template="disabilitiesCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_WithDisabilities'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isHomeless'"
                                       :title="$t('reportData.participants.isHomeless')"
                                       :width="170"
                                       :template="homelessCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsHomeless'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isDisadvantaged'"
                                       :title="$t('reportData.participants.isDisadvantaged')"
                                       :width="200"
                                       :template="disadvantagedCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsDisadvantaged'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'isFromUnemployedHousehold'"
                                       :title="$t('reportData.participants.isFromUnemployedHousehold')"
                                       :width="170"
                                       :template="unemployedHouseHoldCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_IsFromUnemployedHousehold'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'withDependentChildren'"
                                       :title="$t('reportData.participants.withDependentChildren')"
                                       :width="170"
                                       :template="childrenCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_WithDependentChildren'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'fromOneMemberHousehold'"
                                       :title="$t('reportData.participants.fromOneMemberHousehold')"
                                       :width="170"
                                       :template="oneMemberCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_FromOneMemberHousehold'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdByUserName'"
                                       :title="$t('reportData.participants.createdByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'createdAt'"
                                       :title="$t('reportData.participants.createdAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedByUserName'"
                                       :title="$t('reportData.participants.updatedByUserName')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'updatedAt'"
                                       :title="$t('reportData.participants.updatedAt')"
                                       :width="200"
                                       :format="customDateTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'consentToBeProcessed'"
                                       :title="$t('reportData.participants.consentToBeProcessed')"
                                       :width="150"
                                       :template="consentCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'m_ConsentToBeProcessed'"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'participantMigrationId'"
                                       :title="$t('reportData.participants.participantMigrationId')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMigrationId'"
                                       :title="$t('reportData.participants.eventMigrationId')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventVenue'"
                                       :title="$t('reportData.events.eventVenue')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLocation'"
                                       :title="$t('reportData.events.eventLocation')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventMainActivity'"
                                       :title="$t('reportData.events.eventMainActivity')"
                                       :width="150">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDirectorate'"
                                       :title="$t('reportData.events.eventDirectorate')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventActivityDirection'"
                                       :title="$t('reportData.events.eventActivityDirection')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventSort'"
                                       :title="$t('reportData.events.eventSort')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventFundingType'"
                                       :title="$t('reportData.events.eventFundingType')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventProjectName'"
                                       :title="$t('reportData.events.eventProjectName')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventForm'"
                                       :title="$t('reportData.events.eventForm')"
                                       :width="170">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventOrganizerName'"
                                       :title="$t('reportData.events.eventOrganizerName')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStartDate'"
                                       :title="$t('reportData.events.eventStartDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDate')"
                                       :width="150"
                                       :format="customDateFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventEndDate'"
                                       :title="$t('reportData.events.eventEndDateHour')"
                                       :width="150"
                                       :format="customTimeFormat">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLegalArea'"
                                       :title="$t('reportData.events.eventLegalArea')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'thematicArea'"
                                       :title="$t('reportData.events.thematicArea')"
                                       :width="500">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventStatus'"
                                       :title="$t('reportData.events.eventStatus')"
                                       :width="200">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventDescription'"
                                       :title="$t('reportData.events.eventDescription')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventExpectedResults'"
                                       :title="$t('reportData.events.eventExpectedResults')"
                                       :width="400">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventLearningGoals'"
                                       :title="$t('reportData.events.eventLearningGoals')"
                                       :width="300">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'excludeFromReporting'"
                                       :title="$t('reportData.events.excludeFromReporting')"
                                       :width="200"
                                       :template="excludeCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'deleted'"
                                       :title="$t('reportData.participants.deleted')"
                                       :width="170"
                                       :template="deletedCellTemplate">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'archived'"
                                       :title="$t('reportData.events.archived')"
                                       :width="170"
                                       :template="archivedCellTemplate">
                    </kendo-grid-column>
                </kendo-grid>
            </div>

        </div>

        <DetailsModal v-model="detailsModel" :show="showDetails" @onClose="onDetailsClose"></DetailsModal>
        <ParticipantDetailsModal v-model="participantDetailsModel" :show="showParticipantDetails" @onClose="onParticipantDetailsClose"></ParticipantDetailsModal>
        <PersonEditModal v-model="personModel"
                         :show="showPersonEdit"
                         @onClose="onPersonEditClose"
                         @onSave="onPersonEdit">
        </PersonEditModal>
        <ParticipantEditModal v-model="participantModel"
                              :show="showParticipantEdit"
                              @onClose="onParticipantEditClose"
                              @onSave="onParticipantEdit">
        </ParticipantEditModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import store from '../../store/store';
    import BtnsTemplate from "../../components/grid/StandardBtnsTemplate";
    import PageTitle from '../../components/common/PageTitle';
    import { RegisterFieldValueQueryFilter } from '../../models/enums';
    import DetailsModal from '../../components/dynamic/register/details.modal';
    import ParticipantDetailsModal from '../../components/participants/details.modal';
    import PersonEditModal from "../../components/person/edit.modal";
    import ParticipantEditModal from "../../components/participants/edit.modal";
    import personService from "../../services/person.service";
    import participantService from "../../services/participant.service";
    import DateOnlyPicker from "@/components/datepicker/DateOnlyPicker";
    import { mapGetters } from 'vuex'


    export default {
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            }
        },
        components: {
            PageTitle,
            DetailsModal,
            ParticipantDetailsModal,
            PersonEditModal,
            ParticipantEditModal,
            DateOnlyPicker
        },
        data() {
            return {
                componentName: "participantsReportData",
                titleKey: 'reportData.participants.pageTitle',
                defaultGridRows: this.$store.getters.defaultGridRows,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    participantMigrationId: { name: 'participantMigrationId', type: 'number', editable: false, nullable: true, visible: true },
                    registerEntityId: { name: 'registerEntityId', type: 'number', editable: false, nullable: true, visible: true },
                    eventMigrationId: { name: 'eventMigrationId', type: 'number', editable: false, nullable: true, visible: true },
                    partRequsetFillDate: { name: 'partRequsetFillDate', type: 'date', editable: false, nullable: true, visible: true },
                    m_PartRequsetFillDate: { name: 'm_PartRequsetFillDate', type: 'date', related: 'partRequsetFillDate', editable: false, nullable: true, visible: true },
                    gender: { name: 'gender', type: 'string', editable: false, nullable: true, visible: true },
                    m_Gender: { name: 'm_Gender', type: 'string', related: 'gender', editable: false, nullable: true, visible: true },
                    title: { name: 'title', type: 'string', editable: false, nullable: true, visible: true },
                    m_Title: { name: 'm_Title', type: 'string', related: 'title', editable: false, nullable: true, visible: true },
                    salutation: { name: 'salutation', type: 'string', editable: false, nullable: true, visible: true },
                    salutationEn: { name: 'salutationEn', type: 'string', editable: false, nullable: true, visible: true },
                    egn: { name: 'egn', type: 'string', editable: false, nullable: true, visible: true },
                    m_EGN: { name: 'm_EGN', type: 'string', related: 'egn', editable: false, nullable: true, visible: true },
                    fullName: { name: 'fullName', type: 'string', editable: false, nullable: true, visible: true },
                    fullNameEn: { name: 'fullNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    firstName: { name: 'firstName', type: 'string', editable: false, nullable: true, visible: true },
                    m_FirstName: { name: 'm_FirstName', type: 'string', related: 'firstName', editable: false, nullable: true, visible: true },
                    middleName: { name: 'middleName', type: 'string', editable: false, nullable: true, visible: true },
                    m_MiddleName: { name: 'm_MiddleName', type: 'string', related: 'middleName', editable: false, nullable: true, visible: true },
                    lastName: { name: 'lastName', type: 'string', editable: false, nullable: true, visible: true },
                    m_LastName: { name: 'm_LastName', type: 'string', related: 'lastName', editable: false, nullable: true, visible: true },
                    position: { name: 'position', type: 'string', editable: false, nullable: true, visible: true },
                    m_Position: { name: 'm_Position', type: 'string', related: 'position', editable: false, nullable: true, visible: true },
                    migrationInstitutionName: { name: 'migrationInstitutionName', type: 'string', editable: false, nullable: true, visible: true },
                    m_InstitutionName: { name: 'migrationInstitutionName', type: 'string', related: 'institutionName', editable: false, nullable: true, visible: true },
                    migrationInstitutionCity: { name: 'migrationInstitutionCity', type: 'string', editable: false, nullable: true, visible: true },
                    institutionName: { name: 'institutionName', type: 'string', editable: false, nullable: true, visible: true },
                    institutionNameEn: { name: 'institutionNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    institutionCity: { name: 'institutionCity', type: 'string', editable: false, nullable: true, visible: true },
                    m_InstitutionCity: { name: 'm_InstitutionCity', type: 'string', related: 'institutionCity', editable: false, nullable: true, visible: true },
                    phone: { name: 'phone', type: 'string', editable: false, nullable: true, visible: true },
                    m_Phone: { name: 'm_Phone', type: 'string', related: 'phone', editable: false, nullable: true, visible: true },
                    mobilePhone: { name: 'mobilePhone', type: 'string', editable: false, nullable: true, visible: true },
                    m_MobilePhone: { name: 'm_MobilePhone', type: 'string', related: 'mobilePhone', editable: false, nullable: true, visible: true },
                    email: { name: 'email', type: 'string', editable: false, nullable: true, visible: true },
                    m_Email: { name: 'm_Email', type: 'string', related: 'email', editable: false, nullable: true, visible: true },
                    participationCode: { name: 'participationCode', type: 'number', editable: false, nullable: true, visible: true },
                    participationName: { name: 'participationName', type: 'string', editable: false, nullable: true, visible: true },
                    m_ParticipationName: { name: 'm_ParticipationName', type: 'string', related: 'participationName', editable: false, nullable: true, visible: true },
                    reasonForAdmission: { name: 'reasonForAdmission', type: 'string', editable: false, nullable: true, visible: true },
                    m_ReasonForAdmission: { name: 'm_ReasonForAdmission', type: 'string', related: 'reasonForAdmission', editable: false, nullable: true, visible: true },
                    deployed: { name: 'deployed', type: 'string', editable: false, nullable: true, visible: true },
                    m_Deployed: { name: 'm_Deployed', type: 'string', related: 'deployed', editable: false, nullable: true, visible: true },
                    cityOfCurrentAddress: { name: 'cityOfCurrentAddress', type: 'string', editable: false, nullable: true, visible: true },
                    m_CityOfCurrentAddress: { name: 'm_CityOfCurrentAddress', type: 'string', related: 'cityOfCurrentAddress', editable: false, nullable: true, visible: true },
                    accommodationRequest: { name: 'accommodationRequest', type: 'string', editable: false, nullable: true, visible: true },
                    m_AccommodationRequest: { name: 'm_AccommodationRequest', type: 'string', related: 'accommodationRequest', editable: false, nullable: true, visible: true },
                    datesForNights: { name: 'datesForNights', type: 'string', editable: false, nullable: true, visible: true },
                    m_DatesForNights: { name: 'm_DatesForNights', type: 'string', related: 'datesForNights', editable: false, nullable: true, visible: true },
                    roomType: { name: 'roomType', type: 'string', editable: false, nullable: true, visible: true },
                    m_RoomType: { name: 'm_RoomType', type: 'string', related: 'roomType', editable: false, nullable: true, visible: true },
                    travelers: { name: 'travelers', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_Travelers: { name: 'm_Travelers', type: 'boolean', related: 'travelers', editable: false, nullable: true, visible: true },
                    vegetarianMenu: { name: 'vegetarianMenu', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_VegetarianMenu: { name: 'm_VegetarianMenu', type: 'boolean', related: 'vegetarianMenu', editable: false, nullable: true, visible: true },
                    note: { name: 'note', type: 'string', editable: false, nullable: true, visible: true },
                    m_Note: { name: 'm_Note', type: 'string', related: 'note', editable: false, nullable: true, visible: true },
                    positionStatistics: { name: 'positionStatistics', type: 'string', editable: false, nullable: true, visible: true },
                    m_PositionStatistics: { name: 'm_PositionStatistics', type: 'string', related: 'positionStatistics', editable: false, nullable: true, visible: true },
                    isMigrant: { name: 'isMigrant', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsMigrant: { name: 'm_IsMigrant', type: 'boolean', related: 'isMigrant', editable: false, nullable: true, visible: true },
                    isForeigner: { name: 'isForeigner', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsForeigner: { name: 'm_IsForeigner', type: 'boolean', related: 'isForeigner', editable: false, nullable: true, visible: true },
                    isMemberOfAMinority: { name: 'isMemberOfAMinority', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsMemberOfAMinority: { name: 'm_IsMemberOfAMinority', type: 'boolean', related: 'isMemberOfAMinority', editable: false, nullable: true, visible: true },
                    isOfGypsyOrigin: { name: 'isOfGypsyOrigin', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsOfGypsyOrigin: { name: 'm_IsOfGypsyOrigin', type: 'boolean', related: 'isOfGypsyOrigin', editable: false, nullable: true, visible: true },
                    withDisabilities: { name: 'withDisabilities', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_WithDisabilities: { name: 'm_WithDisabilities', type: 'boolean', related: 'withDisabilities', editable: false, nullable: true, visible: true },
                    isHomeless: { name: 'isHomeless', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsHomeless: { name: 'm_IsHomeless', type: 'boolean', related: 'isHomeless', editable: false, nullable: true, visible: true },
                    isDisadvantaged: { name: 'isDisadvantaged', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsDisadvantaged: { name: 'm_IsDisadvantaged', type: 'boolean', related: 'isDisadvantaged', editable: false, nullable: true, visible: true },
                    isFromUnemployedHousehold: { name: 'isFromUnemployedHousehold', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_IsFromUnemployedHousehold: { name: 'm_IsFromUnemployedHousehold', type: 'boolean', related: 'isFromUnemployedHousehold', editable: false, nullable: true, visible: true },
                    withDependentChildren: { name: 'withDependentChildren', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_WithDependentChildren: { name: 'm_WithDependentChildren', type: 'boolean', related: 'withDependentChildren', editable: false, nullable: true, visible: true },
                    fromOneMemberHousehold: { name: 'fromOneMemberHousehold', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_FromOneMemberHousehold: { name: 'm_FromOneMemberHousehold', type: 'boolean', related: 'fromOneMemberHousehold', editable: false, nullable: true, visible: true },
                    createdByUserName: { name: 'createdByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    createdAt: { name: 'createdAt', type: 'date', editable: false, nullable: true, visible: true },
                    updatedByUserName: { name: 'updatedByUserName', type: 'string', editable: false, nullable: true, visible: true },
                    updatedAt: { name: 'updatedAt', type: 'date', editable: false, nullable: true, visible: true },
                    employment: { name: 'employment', type: 'string', editable: false, nullable: true, visible: true },
                    m_Employment: { name: 'm_Employment', type: 'string', related: 'employment', editable: false, nullable: true, visible: true },
                    education: { name: 'education', type: 'string', editable: false, nullable: true, visible: true },
                    m_Education: { name: 'm_Education', type: 'string', related: 'education', editable: false, nullable: true, visible: true },
                    consentToBeProcessed: { name: 'consentToBeProcessed', type: 'boolean', editable: false, nullable: true, visible: true },
                    m_ConsentToBeProcessed: { name: 'm_ConsentToBeProcessed', type: 'boolean', related: 'consentToBeProcessed', editable: false, nullable: true, visible: true },
                    participationTypeName: { name: 'participationTypeName', type: 'string', editable: false, nullable: true, visible: true },
                    participationTypeNameEn: { name: 'participationTypeNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    statusName: { name: 'statusName', type: 'string', editable: false, nullable: true, visible: true },

                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    eventStartDate: { name: 'eventStartDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventEndDate: { name: 'eventEndDate', type: 'date', editable: false, nullable: true, visible: true },
                    eventVenue: { name: 'eventVenue', type: 'string', editable: false, nullable: true, visible: true },
                    eventLocation: { name: 'eventLocation', type: 'string', editable: false, nullable: true, visible: true },
                    eventMainActivity: { name: 'eventMainActivity', type: 'string', editable: false, nullable: true, visible: true },
                    eventDirectorate: { name: 'eventDirectorate', type: 'string', editable: false, nullable: true, visible: true },
                    eventActivityDirection: { name: 'eventActivityDirection', type: 'string', editable: false, nullable: true, visible: true },
                    eventLegalArea: { name: 'eventLegalArea', type: 'string', editable: false, nullable: true, visible: true },
                    eventFundingType: { name: 'eventFundingType', type: 'string', editable: false, nullable: true, visible: true },
                    eventProjectName: { name: 'eventProjectName', type: 'string', editable: false, nullable: true, visible: true },
                    eventOrganizerName: { name: 'eventOrganizerName', type: 'string', editable: false, nullable: true, visible: true },
                    eventSort: { name: 'eventSort', type: 'string', editable: false, nullable: true, visible: true },
                    eventForm: { name: 'eventForm', type: 'string', editable: false, nullable: true, visible: true },
                    thematicArea: { name: 'thematicArea', type: 'string', editable: false, nullable: true, visible: true },
                    eventStatus: { name: 'eventStatus', type: 'string', editable: false, nullable: true, visible: true },
                    eventStatusEn: { name: 'eventStatusEn', type: 'string', editable: false, nullable: true, visible: true },
                    eventDescription: { name: 'eventDescription', type: 'string', editable: false, nullable: true, visible: true },
                    eventExpectedResults: { name: 'eventExpectedResults', type: 'string', editable: false, nullable: true, visible: true },
                    eventLearningGoals: { name: 'eventLearningGoals', type: 'string', editable: false, nullable: true, visible: true },
                    excludeFromReporting: { name: 'excludeFromReporting', type: 'boolean', editable: false, nullable: true, visible: true },
                    archived: { name: 'archived', type: 'boolean', editable: false, nullable: true, visible: true },
                    deleted: { name: 'deleted', type: 'boolean', editable: false, nullable: true, visible: true },
                    hasDiffs: { name: 'hasDiffs', type: 'boolean', editable: false, nullable: true, visible: true },

                },
                rawHtml: '',
                transportSettings: {
                    read: {
                        url: `${store.getters.baseUrl}/api/reportData/nipToMigrationParticipants`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: 'NipToMigrationParticipants.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                showReportDataParticipantsToMigrationSettings: false,
                showReportDataParticipantsToMigrationSettingsForm: false,
                searchQuery: '',
                selectedEventFilter: '',
                detailsModel: null,
                showDetails: false,
                participantDetailsModel: null,
                showParticipantDetails: false,
                diffCheckerFilter: [],
                diffCheckerFilterStartDate: new Date(new Date().getFullYear(), 0, 1, 12),
                personModel: null,
                participantModel: null,
                showParticipantEdit: false,
                showPersonEdit: false,
            }
        },
        methods: {
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            goToExportTemplate() {
            },
            selectImportFiles() {
            },
            goToImportFromExcel(args) {
            },
            dataBound(e) {
                if (e.sender.options.dataSourceRef === 'datasource1' && !this.showReportDataParticipantsToMigrationSettings) {
                    this.showReportDataParticipantsToMigrationSettings = true;
                }

                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.hasDiffs) {
                        $(item).addClass("left-border-danger");
                    }
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    this.saveState();
                    let newOptions = {
                        request: options,
                        diffCheckerFilterStartDate: this.diffCheckerFilterStartDate,
                        diffCheckerFilter: this.diffCheckerFilter
                            ? this.diffCheckerFilter.filter(x => x.checked === true).map(x => x.key)
                            : []
                    };

                    return kendo.stringify(newOptions);
                }
            },
            saveState: function () {
                let grid = this.$refs.reportDataParticipantsToMigrationGrid.kendoWidget();

                localStorage["participants-to-migration-reportdata-grid-options"] = kendo.stringify(grid.getOptions());
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            toolbarTemplate: function () {
                let templateHtml =
                    '<span>' +
                    '<a class="k-pager-refresh k-link k-button" title="Refresh"><span class="k-icon k-i-reload"></span></a>' +
                    '</span>';

                return kendo.template(templateHtml);
            },
            travelersCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.travelers ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.travelers ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            menuCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.vegetarianMenu ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.vegetarianMenu ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            migrantCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isMigrant ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isMigrant ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            foreignerCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isForeigner ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isForeigner ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            minorityCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isMemberOfAMinority ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isMemberOfAMinority ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            gipsyCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isOfGypsyOrigin ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isOfGypsyOrigin ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            disabilitiesCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.withDisabilities ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.withDisabilities ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            homelessCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isHomeless ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isHomeless ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            disadvantagedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isDisadvantaged ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isDisadvantaged ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            unemployedHouseHoldCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.isFromUnemployedHousehold ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.isFromUnemployedHousehold ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            childrenCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.withDependentChildren ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.withDependentChildren ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            oneMemberCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.fromOneMemberHousehold ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.fromOneMemberHousehold ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            consentCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.consentToBeProcessed ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.consentToBeProcessed ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            hasDiffsCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.hasDiffs ? 'badge-danger' : 'badge-light') + '">' + kendo.htmlEncode(dataItem.hasDiffs ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            yesNoCellTemplate: function (dataItem, dataItemField) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem[dataItemField] ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem[dataItemField] ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            excludeCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.excludeFromReporting ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.excludeFromReporting ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            archivedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.archived ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.archived ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            deletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<div class="text-center"><span class="badge ' + (dataItem.deleted ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.deleted ? this.$t('yes') : this.$t('no')) + '</span></div>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.reportDataParticipantsToMigrationGrid,
                        btns: [{
                            name: "eventDetails",
                            text: "",
                            tooltip: this.$t('buttons.eventDetails.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.eventDetailsBtnClick
                        },
                        {
                            name: "participantDetails",
                            text: "",
                            tooltip: this.$t('buttons.participantDetails.btnText'),
                            class: 'btn btn-primary',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.participantDetailsBtnClick
                        },
                        {
                            name: "participantEditNew",
                            text: "",
                            tooltip: this.$t("buttons.edit.btnText"),
                            class: "btn btn-primary",
                            icon: "fas fa-edit",
                            show: this.hasParticipantEditRights,
                            clickHandler: this.participantEditNewBtnClick,
                        },
                        {
                            name: "personEdit",
                            text: "",
                            tooltip: this.$t("buttons.personEdit.btnText"),
                            class: "btn btn-primary",
                            icon: "fas fa-user-cog",
                            show: this.hasPersonEditRights,
                            clickHandler: this.personEditBtnClick,
                        }
                        ]
                    }
                };
            },
            eventDetailsBtnClick(args) {
                this.showEventDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            showEventDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onDetailsClose() {
                this.showDetails = false;
                this.detailsModel = null;
            },
            participantDetailsBtnClick(args) {
                this.showParticipantDetailsModal(args);
            },
            showParticipantDetailsModal(args) {
                this.$api.participant
                    .get(args.id)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.participantDetailsModel = model;
                            this.showParticipantDetails = true;
                        }
                    })
                    .catch(error => {
                        this.participantDetailsModel = null;
                        this.showParticipantDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onParticipantDetailsClose() {
                this.showParticipantDetails = false;
                this.participantDetailsModel = null;
            },
            changeGridSettings(gridName) {
                if (gridName === 'reportDataParticipantsToMigrationGrid') {
                    this.showReportDataParticipantsToMigrationSettingsForm = !this.showReportDataParticipantsToMigrationSettingsForm;
                }
            },
            refresh() {
                this.$refs['reportDataParticipantsToMigrationGrid'].kendoWidget().dataSource.read();
            },
            clearFilters() {
                this.searchQuery = '';

                if (this.diffCheckerFilter) {
                    this.diffCheckerFilter.forEach(x => {
                        x.checked = false;
                    });
                }
                const grid = this.$refs.reportDataParticipantsToMigrationGrid;
                if (grid) {
                    grid.kendoWidget().dataSource.sort({});
                    grid.kendoWidget().dataSource.page(1);
                    grid.kendoWidget().dataSource.aggregate([]);
                    grid.kendoWidget().dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.reportDataParticipantsToMigrationGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            excelExport() {
                let id = this.selectedEventFilterId;

                this.$http.get('/api/reportData/participantsExcelExport/' + id, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', this.registerName + '.xlsx');
                        document.body.appendChild(link);
                        link.click();
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            hideUnselected() {
                const grid = this.$refs.reportDataParticipantsToMigrationGrid.kendoWidget();
                if (!grid) return;

                const toShow = this.diffCheckerFilter.filter(x => x.checked)
                    .reduce((arr, el) => {
                        return [...arr, ...[el.key, el.related]];
                    }, [])

                let columns = grid.columns;

                // loop through the columns and set the columns.hidden option
                columns.forEach(col => {
                    if (!col.locked && !toShow.includes(col.field) && !toShow.includes(col.title) && !col.hidden) {
                        grid.hideColumn(col);
                    } else {
                        if (col.hidden) {
                            grid.showColumn(col);
                        }
                    }
                });

                this.refresh();
            },
            showUnselected() {
                let grid = this.$refs.reportDataParticipantsToMigrationGrid.kendoWidget();
                if (!grid) return;

                let columns = grid.columns;
                // loop through the columns and set the columns.hidden option
                columns.forEach(col => {
                    if (col.hidden) {
                        grid.showColumn(col);
                    }
                });
            },
            participantEditNewBtnClick(args) {
                if (!this.hasParticipantEditRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.showParticipantEditModal(args.id);
            },
            onParticipantEdit(item) {
                this.refresh();
            },
            onParticipantEditClose() {
                this.showParticipantEdit = false;
                this.participantModel = null;
            },
            personEditBtnClick(args) {
                if (!this.hasPersonEditRights) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonEditModal(args.personId);
            },
            onPersonEdit(item) {
                this.refresh();
            },
            onPersonEditClose() {
                this.showPersonEdit = false;
                this.personModel = null;
            },
            showParticipantEditModal(id) {
                participantService
                    .getById(id)
                    .then((response) => {
                        let model = response.data.participant;
                        if (model) {
                            this.participantModel = model;
                            this.showParticipantEdit = true;
                        } else {
                            this.participantModel = null;
                            this.showParticipantEdit = false;
                        }
                    })
                    .catch((error) => {
                        this.participantModel = null;
                        this.showParticipantEdit = false;

                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            showPersonEditModal(id) {
                personService
                    .getById(id)
                    .then((response) => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonEdit = true;
                        } else {
                            this.editModel = null;
                            this.showPersonEdit = false;
                        }
                    })
                    .catch((error) => {
                        this.personModel = null;
                        this.showPersonEdit = false;

                        this.$vs.notify({
                            title: this.$t(
                                "request.response.status." +
                                this.$helpers.errorStatusCode(error)
                            ),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration,
                        });
                    });
            },
            setFilterYear(add) {
                this.diffCheckerFilterStartDate = new Date(this.diffCheckerFilterStartDate.getFullYear() + add, 0, 1, 12)
            }
        },
        mounted: function () {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({ container });

            this.diffCheckerFilter = Object.keys(this.schemaModelFields).filter(x => x.indexOf('m_') !== -1)
                .map(x => {
                    return { key: x, checked: false, related: this.schemaModelFields[x].related };
                });
        },
        computed: {
            ...mapGetters(['timeFormat', 'dateFormat', 'dateTimeFormat', 'isEnVersion', 'claims']),
            customTimeFormat() {
                return `{0:${this.timeFormat}}`
            },
            customDateFormat() {
                return `{0:${this.dateFormat}}`
            },
            customDateTimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            },
            hasEventReadRights() {
                return this.claims.event.read;
            },
            hasParticipantReadRights() {
                return this.claims.participant.read;
            },
            hasParticipantEditRights() {
                return this.claims.participant.update;
            },
            hasPersonEditRights() {
                return this.claims.person.update;
            },
            token: function () {
                return store.getters.authToken;
            },
            selectedEventFilterId() {
                let id = Number(this.selectedEventFilter);
                return isNaN(id) ? 0 : id;
            },
            hasDiffCheckerFilter() {
                return this.diffCheckerFilter && this.diffCheckerFilter.some(x => x.checked);
            }
        }
    }
</script>

<style scoped>
    .btn {
        margin-right: 10px;
        margin-left: 5px;
    }

    .checkbox {
        margin-right: 5px;
    }

    .selectFile {
        display: none;
    }

    .inlineForm {
        display: inline;
    }
</style>

<style lang="scss">
    .grid-wrapper {
        overflow-x: auto;
    }

    tr.left-border-danger {
        &:hover

    {
        color: rgba(255, 0, 0, 0.7) !important;
    }

    td:first-child {
        border-left: 3px solid rgba(255, 0, 0, 0.5) !important;
    }

    }

    tr.left-border-blue {
        &:hover

    {
        color: #3498db !important;
    }

    td:first-child {
        border-left: 4px solid #3498db !important;
    }

    }

    tr.left-border-green {
        &:hover

    {
        color: #4caf50 !important;
    }

    td:first-child {
        border-left: 4px solid #4caf50 !important;
    }

    }

    tr.left-border-secondary {
        &:hover

    {
        color: #707a8a !important;
    }

    td:first-child {
        border-left: 4px solid #707a8a !important;
    }

    }

    .k-grid td {
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>
